import ThumbRenderer from "./ThumbRenderer"
import { showMoreButtonStyle, showMoreButtonTextStyle } from "./styles"
import { PublishedAsset } from "@ncs/ncs-api/src/portal-apps/point-of-sale/types"

type ThumbnailListProps = {
	assets: PublishedAsset[]
	selectedAsset: string | null
	onThumbnailClick: (id: string) => void
	onExpand?: (asset: PublishedAsset) => void
	mode: "partial" | "full"
}

const ThumbnailList: React.FC<ThumbnailListProps> = ({
	assets,
	selectedAsset,
	onThumbnailClick,
	onExpand,
	mode = "partial",
}) => {
	return (
		<>
			{assets.slice(0, mode === "partial" ? 3 : assets.length).map((asset, idx) => (
				<ThumbRenderer
					key={asset.id}
					asset={asset}
					isSelected={selectedAsset === asset.id.toString()}
					onClick={() => onThumbnailClick(asset.id.toString())}
					priority={idx === 0 ? "high" : "auto"}
				/>
			))}
			{assets.length > 3 && mode === "partial" && (
				<div css={showMoreButtonStyle}>
					<button
						onClick={() => onExpand?.(assets[3])}
						css={showMoreButtonTextStyle}
						type="button"
						aria-label={`Show ${assets.length - 3} more images`}
					>
						+{assets.length - 3}
					</button>
				</div>
			)}
		</>
	)
}

export default ThumbnailList
